import React from "react";

import { Props } from "./types";
import { CompletionInput } from "./completionInput";
import styles from "./styles.scss";

function Completion({ completion, readOnly, submit }: Props) {
  return (
    <div className={styles.completion}>
      <CompletionInput
        completion={completion}
        readOnly={readOnly}
        submit={(completion) => {
          submit(completion > 100 ? 100 : completion);
        }}
      />
    </div>
  );
}

export { Completion };
